/**
 * localStorage persistence layer for user-defined custom armour.
 *
 * Keys:
 *   frostgrave:custom-armour   → Armour[]  (full hydrated objects)
 */

import { Armour } from '../types';

const KEY = 'frostgrave:custom-armour';

function readAll(): Armour[] {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? (JSON.parse(raw) as Armour[]) : [];
  } catch {
    return [];
  }
}

function writeAll(armours: Armour[]): void {
  localStorage.setItem(KEY, JSON.stringify(armours));
}

export const customArmourService = {
  getAll(): Armour[] {
    return readAll();
  },

  create(data: Omit<Armour, 'id'>): Armour {
    const armour: Armour = { ...data, id: crypto.randomUUID() };
    writeAll([...readAll(), armour]);
    return armour;
  },

  update(id: string, data: Partial<Omit<Armour, 'id'>>): Armour | null {
    const all = readAll();
    const idx = all.findIndex((a) => a.id === id);
    if (idx === -1) return null;
    const updated: Armour = { ...all[idx], ...data, id };
    const next = [...all];
    next[idx] = updated;
    writeAll(next);
    return updated;
  },

  delete(id: string): void {
    writeAll(readAll().filter((a) => a.id !== id));
  },

  /** Overwrites the entire local list — used when applying a Drive download. */
  replaceAll(armours: Armour[]): void {
    writeAll(armours);
  },
};
